import React from 'react';
var VeltCommentPin = function (props) {
    var children = props.children, annotationId = props.annotationId, multiThreadAnnotationId = props.multiThreadAnnotationId, variant = props.variant;
    return (React.createElement("velt-comment-pin", { "annotation-id": annotationId, "multi-thread-annotation-id": multiThreadAnnotationId, variant: variant }, children));
};
export default VeltCommentPin;
